module.exports = __webpack_public_path__ + "media/500HzTriangle.0cee3195.wav";